import styled from "styled-components"

export interface StyledItemProps {
  default_open: boolean
}
export interface StyledItemHeaderProps {
  is_open: boolean
}
export interface StyledItemContentProps {
  is_open: boolean
}

export const StyledItem = styled.div<StyledItemProps>`
  max-width: ${props => props.theme.breakPoints.tablet};
  margin-top: -1px;

  &:nth-of-type(1) {
    margin-top: 0;
  }
`
export const StyledItemHeader = styled.header<StyledItemHeaderProps>`
  display: flex;
  border-top: 1px solid ${(props) => props.theme.colors.darkGrey};
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 16px 0;

  & p {
    ${(props) => props.theme.mixins.bold};
    padding-right: 16px;
  }
  & div {
    transition: 0.2s;
    ${(props) =>
      props.is_open &&
      `
            transform: rotate(180deg);
        `}
  }
`
export const StyledItemContent = styled.div<StyledItemContentProps>`
  transition: 0.2s;
  border-bottom: 1px solid ${(props) => props.theme.colors.darkGrey};
  overflow: hidden;
  ${(props) =>
    props.is_open
      ? `
        display: block;
    `
      : `
        display: none;
    `}

  & div {
    padding-bottom: 16px;
  }

  & p {
    margin: 8px 0;
    ${(props) => props.theme.mixins.body};
    margin: 16px 0;

    &:nth-of-type(1) {
      margin-top: 0;
    }
    &:nth-last-of-type(1) {
      margin-bottom: 0;
    }
  }
`
